import { gql } from '@grandvisionhq/graphql';

const shoppinglistPricesFragment = gql`
  fragment ShoppinglistPricesFragment on ProductPrices {
    discountedPrice {
      discountInformation {
        value
      }
      price {
        amount
        currencyCode
      }
    }
    originalPrice {
      amount
      currencyCode
    }
  }
`;
const shoppinglistMediaFragment = gql`
  fragment ShoppinglistMediaFragment on Media {
    images {
      url
    }
  }
`;
const shoppinglistVariantFragment = gql`
  fragment ShoppinglistVariantFragment on Variant {
    ... on AccessoriesVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
      variantTypeDetails {
        color
        channelAvailability
      }
    }
    ... on ContactLensVariant {
      gan
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
      variantTypeDetails {
        lensType
        packageQuantity
        channelAvailability
      }
    }
    ... on FrameVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
      variantTypeDetails {
        frameFeatures {
          color
          size {
            size
          }
        }
        channelAvailability
      }
    }
    ... on LensTypeVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on PrescriptionGlassesPackageOptionsVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on PrescriptionGlassesPackageVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on ReadyReaderVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
      variantTypeDetails {
        nullableFrameFeatures: frameFeatures {
          color
          size {
            size
          }
        }
        channelAvailability
      }
    }
    ... on SolutionVariant {
      gan
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
    }
    ... on SunglassesVariant {
      prices {
        ...ShoppinglistPricesFragment
      }
      media {
        ...ShoppinglistMediaFragment
      }
      variantTypeDetails {
        lensFeatures {
          lensColor
        }
        nullableFrameFeatures: frameFeatures {
          color
          size {
            size
          }
        }
        channelAvailability
      }
    }
  }
  ${shoppinglistMediaFragment}
  ${shoppinglistPricesFragment}
`;
const shoppinglistVariantOverviewFragment = gql`
  fragment ShoppinglistVariantOverviewFragment on Shoppinglist {
    id
    items {
      variant {
        isAllowBackOrder
        sku
        ...ShoppinglistVariantFragment
        inventory {
          stockIndicator
          items {
            allowBackInStockNotification
          }
          totalQuantity
        }
      }
    }
  }
  ${shoppinglistVariantFragment}
`;
const shoppinglistProductOverviewFragment = gql`
  fragment ShoppinglistProductOverviewFragment on Shoppinglist {
    id
    items {
      name
      quantity
      sku
      product {
        ... on ContactLensProduct {
          id
          productTypeDetails {
            replacementFrequencyAllLocales {
              value
              locale
            }
          }
        }
        slug
      }
    }
  }
`;
const ShoppinglistBasicFragment = gql`
  fragment ShoppinglistBasicFragment on Shoppinglist {
    id
    items {
      sku
      product {
        ... on ContactLensProduct {
          id
        }
        slug
      }
    }
  }
`;

export { ShoppinglistBasicFragment, shoppinglistProductOverviewFragment, shoppinglistVariantFragment, shoppinglistVariantOverviewFragment };
//# sourceMappingURL=shopping-list.js.map
